import { CurrencyDollarIcon } from "@heroicons/react/24/solid";
import { ColumnDef } from "@tanstack/react-table";
import { LineClampedTooltip } from "@/core/components/line-clamped-tooltip";
import { Stack } from "@/core/components/ui/stack";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/core/components/ui/tooltip";
import { SPIFF_APPROVAL_STATUSES } from "@/spiff-approvals";
import type { EnrichedSpiffApproval } from "@/spiff-approvals";
import { DetailedUser } from "@/user/user";

const TechnicianWithPaymentStatusCol = <
  T extends Pick<DetailedUser, "display_identification"> &
    Pick<EnrichedSpiffApproval, "status">,
>(): ColumnDef<T> => ({
  id: "technician-with-payment-status",
  header: "Technician",
  enablePinning: true,
  size: 170,
  minSize: 170,
  maxSize: 170,
  cell: ({ row }) => {
    const data = row.original;
    const showIcon = data.status === SPIFF_APPROVAL_STATUSES.marked_as_paid;

    return (
      <Stack direction="row" align="center" gap="sm">
        <LineClampedTooltip className="line-clamp-1">
          {data.display_identification}
        </LineClampedTooltip>
        {showIcon && (
          <Tooltip>
            <TooltipTrigger aria-label="Marked as paid" asChild>
              <CurrencyDollarIcon className="h-5 w-5 text-interactive-text" />
            </TooltipTrigger>
            <TooltipContent>
              <p>Marked as paid</p>
            </TooltipContent>
          </Tooltip>
        )}
      </Stack>
    );
  },
  accessorFn: (row) => row.display_identification,
});

export default TechnicianWithPaymentStatusCol;
